/* unplugin-vue-components disabled */import script from "./dashboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./dashboard.vue?vue&type=script&setup=true&lang=ts"

import "./dashboard.vue?vue&type=style&index=0&id=ec7f6dba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec7f6dba"]])

export default __exports__